import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { TicketReservationPlugin } from "../../../../../qcloud-models/reservation-plugin/ticket-reservation-plugin";
import { ReservationModuleConfiguration } from "../../../../../qcloud-models/reservation/reservation-module-configuration";
import { WCAGModel } from "../../reservation-wcag/wcag-model";
import { ReservationPluginService } from "../../services/reservation-plugin.service";

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent {
  public wcag: WCAGModel;
  ticketReservation = new TicketReservationPlugin();
  config: ReservationModuleConfiguration;
  constructor(translate: TranslateService,
    public service: ReservationPluginService) {
    this.config = new ReservationModuleConfiguration();
    service.reservationInfo.subscribe(data => {
      this.config = data.configuration;
    });
    translate.setDefaultLang(navigator.language.substring(0, 2));
    this.wcag = new WCAGModel();
    this.wcag.isWCAG = false;
    this.wcag.fontSize = 14;
  }
}
